import {Component, OnInit, ViewChild, HostBinding, inject, ChangeDetectorRef, signal, effect} from '@angular/core';
import {UserService} from "../services/user.service";
import {RoleService} from "../role/role.service";
import {MatSidenav} from "@angular/material/sidenav";
import {Router} from "@angular/router";
import {MessagingService} from "../services/messaging.service";
import {RequirementsService} from "../services/requirements.service";
import {ZendeskService} from "../services/zendesk.service";
import { AdminService } from '../admin/services/admin.service';
import { ListsService } from '../admin/services/lists.service';
import { BrandService } from '../services/brand.service';
import { FieldsService } from '../admin/services/fields.service';
import { WorkService } from '../work/work.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { LocalSelectorComponent } from './local-selector/local-selector.component';
import { Location } from '../models/location.model';
import { User } from '../models/user';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';
import { CdkDragMove } from '@angular/cdk/drag-drop';


@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit {
  priorities_count = 0;

  user: User = { online: false };
  
  works_count = 0;

  isMobile = signal<boolean>(false);
  
  zEshow = true;

  defaultChatWidth = 500;

  chatCurrentWidth = signal<number>(this.defaultChatWidth);

  toggleChat = signal<boolean>((localStorage.getItem("showChat") ?? "true") === "true");

  unreadChat:any = {
    unread: 0,
    mention: 0,
  }
  
  locations: Location[];
  
  allowedNotifications = this.messagingService.messagingToken$;
  
  location;
  
  heading;

  

  @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;

  @HostBinding('class') componentCssClass: string;


  private readonly cdr = inject(ChangeDetectorRef);


  constructor(
    private userService: UserService,
    public roleService: RoleService,
    private _router: Router,
    private messagingService: MessagingService,
    private requirementService: RequirementsService,
    private listsService: ListsService,
    private brandsService: BrandService,
    private fieldsService: FieldsService,
    private requirementsService: RequirementsService,
    private workService: WorkService,
    public adminService: AdminService,
    private zendeskService: ZendeskService,
    private bottomSheet: MatBottomSheet,
    private breakpointObserver: BreakpointObserver
  ) { 
    effect(() => {
      localStorage.setItem("showChat", this.toggleChat().toString());
    })
  }

  ngOnInit() {
    if (Capacitor.isNativePlatform()) {
      StatusBar.setOverlaysWebView({ overlay: false });
    }
    this.messagingService.init();
    this.zendeskService.hide();
    this._router.events.subscribe(() => {
      this.sidenav.close();
      this.zendeskService.hide();
    });

    this.locations = this.adminService.getLocations();
    this.heading = this.adminService.getText('location');

    if(this.locations && this.locations.length === 1){
      this.setLocations(this.locations.map((l)=> l.id))
    } else {
      this.location = localStorage.getItem('locations')
        ? localStorage.getItem('locations').split(",").map(i => parseInt(i))
        : null;
    }

    this.userService.user$.forEach((value:any)=>{
      this.user = value;
      if (this.user?.theme) {
           this.applyTheme(this.user.theme);
         } else {
           this.applyTheme('sky'); 
         }
    });

    this.breakpointObserver.observe(['(max-width: 1080px)']).subscribe((state: BreakpointState) => {
      this.isMobile.set(state.matches);
      if(Capacitor.isNativePlatform()){
        this.isMobile.set(true);
      }
      this.cdr.detectChanges();
    });
    
    this._router.events.subscribe((event) => {
      if(this.isMobile() && event){
        this.toggleChat.set(false);
      }
      this.cdr.detectChanges();
    });
  }

  applyTheme(theme: string) {
    this.componentCssClass = theme;  
    document.body.className = theme;  
  }
 
  setLocations(event){
    localStorage.setItem('locations',event.join(","))
    this.adminService.locations$.next(event);
  }

  openZe(nav){
    this.zendeskService.show();
  }

  closeZe(nav){
    if(this._router.url !== '/main/booking'){
      this.zendeskService.hide();
    }
  }

  logout() {
    this.userService.logout();
  }

  openLocalSelector(): void {
    const ref = this.bottomSheet.open(LocalSelectorComponent);

    ref.afterDismissed().subscribe(() => {
      this.location = localStorage.getItem('locations') ? localStorage.getItem('locations').split(",").map(i => parseInt(i)) : null;
      this.adminService.locations$.next(this.location);
     
    });
  }
  
  requestPermission() {
    this.messagingService.requestPermission();
  }

  toggleSelectAllLocations(event: any): void {
    if (event.checked) {
      this.location = this.locations.map(location => location.id);
    } else {
      this.location = [];
    }
    this.setLocations(this.location);
  }

  areAllSelected(): boolean {
    return this.locations.length > 0 && this.locations.every(loc => this.location?.includes(loc.id));
  }

  setUnread(unreadChat: any) {
    this.unreadChat = unreadChat;
  }

  protected onDragMoved(event: CdkDragMove) {
    this.chatCurrentWidth.set(Math.min(window.innerWidth - 510, window.innerWidth - event.pointerPosition.x));

    // Reset transform so the resizer stays positioned at the sidebar edge
    const element = event.source.element.nativeElement;
    element.style.transform = 'none';
  }
}
